export const newsSelector = state => state.news.get('news');
export const newsCountSelector = state => state.news.get('news').length;
export const loadMoreOffsetSelector = state => state.news.get('loadMoreOffset');
export const newsIsLoadingSelector = state => state.news.get('isLoading');
export const newsIsLoadingMoreSelector = state => state.news.get('isLoadingMore');
export const hasMoreSelector = state => state.news.get('hasMore');
